
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import authCookie from 'utils/authCookie';
import dynamic from 'next/dynamic';
import Rules from 'constants/contents/rules';

const UserArticleLayout = dynamic(
  () => import('features/static/UserArticleLayout'),
);

const ArticleLayout = dynamic(() => import('features/static/ArticleLayout'));
interface RulesPageProps {
  isLoggedIn: boolean;
}

const RulesPage = ({ isLoggedIn }: RulesPageProps) => {
  if (isLoggedIn) {
    return <UserArticleLayout source={<Rules />} title="House Rules" />;
  }

  return <ArticleLayout source={<Rules />} title="Rules" />;
};

export async function getServerSideProps(context) {
  const isLoggedIn = Boolean(authCookie.getIsLoggedIn(context));

  return {
    props: {
      isLoggedIn,
    },
  };
}

export default RulesPage;
